import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { CERTIFICATIONS } from "@/data/content";
import { BadgeCheck, ShieldHalf, Code2, FlaskConical } from "lucide-react";

const ICONS = { BadgeCheck, ShieldHalf, Code2, FlaskConical };

export const Certifications = () => (
    <section id="certifications" data-testid="certifications-section" className="scroll-mt-20 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader
                chapter="07"
                kicker="Credentials"
                title="Certifications & Training"
                testId="certifications-heading"
            />

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                {CERTIFICATIONS.map((cert, i) => {
                    const Icon = ICONS[cert.icon];
                    return (
                        <Reveal key={cert.title} delay={(i % 2) * 0.1}>
                            <article
                                data-testid={`certification-card-${i + 1}`}
                                className="group flex h-full items-start gap-5 border border-white/10 bg-surface/70 p-7 transition-[border-color,box-shadow] duration-500 hover:border-neon/40 hover:shadow-[0_0_28px_rgba(0,255,102,0.08)]"
                            >
                                <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-neon/30 bg-neon/5 text-neon">
                                    <Icon size={20} strokeWidth={1.5} />
                                </span>
                                <div>
                                    <h3 className="font-display text-lg font-bold leading-snug tracking-tight text-zinc-100">
                                        {cert.title}
                                    </h3>
                                    <p className="mt-2 font-mono2 text-xs text-zinc-500">
                                        {cert.provider}
                                    </p>
                                </div>
                            </article>
                        </Reveal>
                    );
                })}
            </div>

            <Reveal delay={0.2}>
                <p className="mt-8 font-mono2 text-[11px] uppercase tracking-[0.2em] text-zinc-600">
                    Credential details and verification links available on request
                </p>
            </Reveal>
        </div>
    </section>
);
